import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Home, Puzzle, Vault, Settings } from 'lucide-react'
import { cn } from '@/lib/utils'

const items = [
  { to: '/', labelKey: 'nav.home', icon: Home, end: true },
  { to: '/vaults', labelKey: 'nav.vaults', icon: Vault },
  { to: '/extension', labelKey: 'nav.extension', icon: Puzzle },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings },
]

export function Sidebar() {
  const { t } = useTranslation()

  return (
    <aside className="hidden w-56 shrink-0 border-r bg-background md:block">
      <nav className="sticky top-14 px-3 py-4">
        <ul className="space-y-1">
          {items.map((it) => {
            const Icon = it.icon
            return (
              <li key={it.to}>
                <NavLink
                  to={it.to}
                  end={it.end}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-secondary text-foreground'
                        : 'text-muted-foreground hover:bg-secondary/60 hover:text-foreground',
                    )
                  }
                >
                  <Icon className="h-4 w-4" />{t(it.labelKey)}
                </NavLink>
              </li>
            )
          })}
        </ul>
      </nav>
    </aside>
  )
}
